<template>
  <div class="container">
    <div class="title has-text-centered">
      My Mentees
    </div>

    <FormErrors v-bind:errors="mentorships.errors.detail" />

    <div class="columns is-centered">
      <div
        class="column is-10"
        style="max-height: min(600px, 60vh); overflow-y: auto;"
      >
        <ul v-if="mentorships.data.length === 0">
          <li
            class="box has-text-centered is-centered has-text-weight-bold has-background-white"
          >
            No mentees
          </li>
        </ul>
        <ul v-else>
          <li>
            <div class="columns is-vcentered">
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Name</p>
              </div>
              <div class="column">
                <p style="font-weight: 700; font-size: larger;">Project Title</p>
              </div>
              <!-- <div class="column" >
                <p style="font-weight: 700; font-size: larger;">Status</p>
              </div> -->
              <div class="column is-2">
                <p style="font-weight: 700; font-size: larger;">Action</p>
              </div>
              <!-- <div class="column"></div> -->
            </div>
          </li>
          <li
            v-for="(mentorship, index) in mentorships.data"
            class="box is-rounded mb-4"
          >
            <div class="columns is-vcentered">
              <div class="column">
                <router-link
                  v-bind:to="{
                    name: 'MenteeProfilePage',
                    params: { profile_uid: mentorship.mentee },
                  }"
                  class="hyperlink"
                >
                  {{ mentorship.mentee_name }}
                </router-link>
              </div>
              <div class="column">
                {{ mentorship.project_title }}
              </div>
              <div class="column is-narrow">
                {{ get_mentorship_status(mentorship.status) }}
              </div>
              <div class="column is-narrow">
                <button v-if="mentorship.status != 1"
                  v-on:click="change_mentorship_status(index, 1)"
                  class="button is-info mr-2"
                  title="On going"
                >
                  <span class="icon"><i class="fas fa-undo"></i></span>
                </button>
                <button v-else
                  v-on:click="change_mentorship_status(index, 1)"
                  class="button is-info mr-2"
                  title="On going"
                  disabled
                >
                  <span class="icon"><i class="fas fa-undo"></i></span>
                </button>
                <button v-if="mentorship.status != 2 && mentorship.status != 3"
                  v-on:click="change_mentorship_status(index, 2)"
                  class="button is-success mr-2"
                  title="Completed"
                >
                  <span class="icon"><i class="fas fa-check"></i></span>
                </button>
                <button v-else
                  v-on:click="change_mentorship_status(index, 2)"
                  class="button is-success mr-2"
                  title="Completed"
                  disabled
                >
                  <span class="icon"><i class="fas fa-check"></i></span>
                </button>
                <!-- TODO Rename reject to decline in backend and frontend -->
                <button v-if="mentorship.status != 3 && mentorship.status != 2"
                  v-on:click="change_mentorship_status(index, 3)"
                  class="button is-danger"
                  title="Rejected"
                >
                  <span class="icon"><i class="fas fa-times"></i></span>
                </button>
                <button v-else
                  v-on:click="change_mentorship_status(index, 3)"
                  class="button is-danger"
                  title="Rejected"
                  disabled
                >
                  <span class="icon"><i class="fas fa-times"></i></span>
                </button>
                <br> <br>
                <router-link v-if="mentorship.status == 1"
                  v-bind:to="{
                    name: 'MentorshipPage',
                    params: { mentorship_uid: mentorship.uid },
                  }"
                  class="button is-info"
                  >Mentorship Page</router-link
                >
                <button v-else
								  class="button is-info mr-2"
								  title="On going"
								  disabled
							  >Mentorship Page </button>
              </div>
              <!-- <div class="column is-narrow"> -->
                <!-- TODO Change the following to router-link to the specific mentor-mentee page -->
                
              <!-- </div> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import axios from '../../api/my-axios';
import FormErrors from '../../components/FormHelpers/FormErrors';

export default {
  components: {
    FormErrors,
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
  data() {
    return {
      mentorships: {
        request_token: {
          // mentor: ""
        },

        errors: {},

        data: [
          // {
          // 	uid: "",
          // 	mentor: "",
          // 	mentee: "",
          // }
        ],
      },
    };
  },
  created() {
    this.mentorships.request_token.mentor = this.user.profile_uid;
    this.get_mentorships();
  },
  methods: {
    get_mentorships() {
      axios
        .get(`/api/mentorship/mentorship/`, {
          params: {
            ...this.mentorships.request_token,
          },
        })
        .then((response) => {
          this.mentorships.data = response.data;
        })
        .catch((error) => {
          this.mentorships.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
    },

    change_mentorship_status(index, status){
      // return
      var mentorship_uid = this.mentorships.data[index].uid
      console.log(this.mentorships.data[index].uid)

      if (status == 1){
        axios
        .post(`/api/mentorship/mentorship/${mentorship_uid}/re_onging/`, {
          params: {
            ...this.mentorships.request_token,
          },
        })
        .then((response) => {
          this.mentorships.data[index].status = 1;
        })
        .catch((error) => {
          this.mentorships.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
      }
      else if (status == 2){
        axios
        .post(`/api/mentorship/mentorship/${mentorship_uid}/finish/`, {
          params: {
            ...this.mentorships.request_token,
          },
        })
        .then((response) => {
          this.mentorships.data[index].status = 2;
        })
        .catch((error) => {
          this.mentorships.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
      }
      else if (status == 3){
        axios
        .post(`/api/mentorship/mentorship/${mentorship_uid}/terminate/`, {
          params: {
            ...this.mentorships.request_token,
          },
        })
        .then((response) => {
          this.mentorships.data[index].status = 3;
        })
        .catch((error) => {
          this.mentorships.errors = error.response
            ? error.response.data
            : { detail: [error.message] };
        });
      }
    },

    get_mentorship_status(status){
      if (status == 1) return "On going";
      else if (status == 2) return "Completed";
      else if (status == 3) return "Rejected";
    }
  },
};
</script>
